import type { Location } from '@virginexperiencedays/products';

export const generateMarkersString = (
  locations: Location[],
  customIconMarkerUrl?: string
): string => {
  const customMarker = customIconMarkerUrl ? `icon:${customIconMarkerUrl}|` : '';

  const markers = locations.map((location) =>
    encodeURI(`markers=${customMarker}${location.lat},${location.lng}`)
  );
  return markers.join('&');
};

export const transformRegionsIntoLocationsArray = (
  regions: { [key: string]: Location[] },
  activeRegion: string
): Location[] => {
  if (typeof regions !== 'object' || regions === null) return [];
  if (typeof activeRegion !== 'string') return [];
  if (activeRegion && !(activeRegion in regions)) return [];

  return activeRegion ? regions[activeRegion] : Object.values(regions).flat();
};
